$(document).ready(function () {
  // 2. This code loads the IFrame Player API code asynchronously.
  var tag = document.createElement("script");

  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  $(
    "#shopify-section-1547471492107 .play-button, .sm-form-header .play-button"
  ).on("click", function (e) {
    e.stopPropagation();
    player5.playVideo();
    $(".header-banner__popup").addClass("active");
    $("body").addClass("video-popup");
  });

  //   $('.header-banner__popup').on('click', function(e) {
  //     e.stopPropagation();
  //   })

  $(window).on("click", function (e) {
    $(".header-banner__popup").removeClass("active");
    $("body").removeClass("video-popup");
    player5.stopVideo();
  });
});

var player5;

window.onYouTubePlayerAPIReady = function () {

  player5 = new YT.Player("video5", {
      events: {
          onReady: isReady,
          onStateChange: headerPlayer,
      },
  });

  $('iframe[id^="video"]').each( function() {
    new YT.Player(this.id, {
      events: {
        onReady: isReady,
        onStateChange: onPlayerStateChange,
      },
    });
  })
  
};

function isReady() {}

//The API will call this function when the video player is ready.
function onPlayerReady(event) {
  event.target.playVideo();
}

// The API calls this function when the player's state changes.
function onPlayerStateChange(event) {
  if (event.data == 1 || event.data == 3) {
    console.log(event.target);
    event.target.h.parentElement.classList += " video-wrapper_playing";
  } else {
    // 		event.target.a.parentElement.classList.remove("video-wrapper_playing");
  }
}

function headerPlayer(event) {
  // 	console.log(event)
}
